import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";

export const GroupFormDialog = ({ open, onOpenChange, editMode, name, setName, onSubmit, saving }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent>
      <DialogHeader>
        <DialogTitle>{editMode ? "Gruppe umbenennen" : "Neue Gruppe"}</DialogTitle>
        <DialogDescription>Name der Kontaktgruppe für das Mailing</DialogDescription>
      </DialogHeader>
      <form onSubmit={onSubmit}>
        <div className="py-2 space-y-2">
          <Label htmlFor="group-name">Name</Label>
          <Input id="group-name" value={name} onChange={(e) => setName(e.target.value)} required autoFocus data-testid="group-name-input" />
        </div>
        <DialogFooter>
          <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>Abbrechen</Button>
          <Button type="submit" disabled={saving} data-testid="group-save-btn">
            {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : "Speichern"}
          </Button>
        </DialogFooter>
      </form>
    </DialogContent>
  </Dialog>
);
